import styled from "@emotion/styled/macro";
import { SvgIcon, SvgNames, tokens } from "@sunrun/experience-ui-components";

type CircleIconProps = {
  name: SvgNames;
  backgroundColor?: string;
  iconColor?: string;
};

const CircleIcon: React.FC<CircleIconProps> = ({
  backgroundColor,
  iconColor,
  name,
}) => {
  const Circle = styled.div`
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background: ${backgroundColor ?? tokens.HEROBLUE_90};
    border-radius: 50%;
    padding: 0.5em;
    height: 1.5em;
    width: 1.5em;
  `;
  const Icon = styled(SvgIcon)`
    height: 1.25em;
    width: 1.25em;
    > path {
      fill: ${iconColor ?? tokens.BLACK};
    }
  `;
  return (
    <Circle>
      <Icon name={name} />
    </Circle>
  );
};

export { CircleIcon };
